import {connect} from "react-redux";
import {IonImg} from '@ionic/react';
import cx from "classnames";
import {MESSAGE_CONTENT_TYPE_NOTE} from "../../../../constants";

const iconGreenPonytail = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_1_3825)">
 <path
  d="M9.36029 9.03125C7.28343 7.07812 5.76041 3.82292 5.20658 2C2.99126 6.16667 -0.525551 14.5 4.7912 14.5C11.4371 14.5 14.5168 12.8705 13.9294 11.7656C13.514 10.9844 11.4783 11.0231 9.36029 9.03125Z"
  fill="black" fillOpacity="0.2"/>
</g>
<path
 d="M9.97365 8.3125C7.72372 6.28125 6.07377 2.89583 5.47379 1C3.07387 5.33333 -0.736014 14 5.0238 14C12.2236 14 15.5599 12.3053 14.9235 11.1562C14.4735 10.3438 12.2681 10.384 9.97365 8.3125Z"
 fill="#E3F9D1"/>
<defs>
 <filter id="filter0_f_1_3825" x="0.5" y="0.5" width="15" height="15.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="0.75" result="effect1_foregroundBlur_1_3825"/>
  </filter>
</defs>
</svg>;

const iconWhitePonytail = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_271_18122)">
 <path
  d="M5.99882 9.03125C7.83967 7.07812 9.18963 3.82292 9.68052 2C11.6441 6.16667 14.7613 14.5 10.0487 14.5C4.15798 14.5 1.42828 12.8705 1.94895 11.7656C2.31713 10.9844 4.12152 11.0231 5.99882 9.03125Z"
  fill="black" fillOpacity="0.2"/>
</g>
<path
 d="M5.45518 8.3125C7.44943 6.28125 8.91188 2.89583 9.44368 1C11.5709 5.33333 14.9478 14 9.84254 14C3.46093 14 0.503754 12.3053 1.06782 11.1562C1.46667 10.3438 3.42143 10.384 5.45518 8.3125Z"
 fill="#F5F5F5"/>
<defs>
 <filter id="filter0_f_271_18122" x="0.386353" y="0.5" width="13.6364" height="15.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="0.75" result="effect1_foregroundBlur_271_18122"/>
 </filter>
</defs>
</svg>;

const iconLightBluePonytail = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_1_3825)">
 <path
  d="M9.36029 9.03125C7.28343 7.07812 5.76041 3.82292 5.20658 2C2.99126 6.16667 -0.525551 14.5 4.7912 14.5C11.4371 14.5 14.5168 12.8705 13.9294 11.7656C13.514 10.9844 11.4783 11.0231 9.36029 9.03125Z"
  fill="black" fillOpacity="0.2"/>
</g>
<path
 d="M9.97365 8.3125C7.72372 6.28125 6.07377 2.89583 5.47379 1C3.07387 5.33333 -0.736014 14 5.0238 14C12.2236 14 15.5599 12.3053 14.9235 11.1562C14.4735 10.3438 12.2681 10.384 9.97365 8.3125Z"
 fill="#DFEFF7"/>
<defs>
 <filter id="filter0_f_1_3825" x="0.5" y="0.5" width="15" height="15.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="0.75" result="effect1_foregroundBlur_1_3825"/>
 </filter>
</defs>
</svg>;

const iconYellowPonytail = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_1_3825)">
 <path
  d="M9.36029 9.03125C7.28343 7.07812 5.76041 3.82292 5.20658 2C2.99126 6.16667 -0.525551 14.5 4.7912 14.5C11.4371 14.5 14.5168 12.8705 13.9294 11.7656C13.514 10.9844 11.4783 11.0231 9.36029 9.03125Z"
  fill="black" fillOpacity="0.2"/>
</g>
<path
 d="M9.97365 8.3125C7.72372 6.28125 6.07377 2.89583 5.47379 1C3.07387 5.33333 -0.736014 14 5.0238 14C12.2236 14 15.5599 12.3053 14.9235 11.1562C14.4735 10.3438 12.2681 10.384 9.97365 8.3125Z"
 fill="#fff9e3"/>
<defs>
 <filter id="filter0_f_1_3825" x="0.5" y="0.5" width="15" height="15.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feGaussianBlur stdDeviation="0.75" result="effect1_foregroundBlur_1_3825"/>
 </filter>
</defs>
</svg>;

const iconBotAvatar = <svg width="15" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path
 d="M0.727273 9C0.534388 9 0.349403 9.07902 0.213013 9.21967C0.0766231 9.36032 0 9.55109 0 9.75V11.25C0 11.4489 0.0766231 11.6397 0.213013 11.7803C0.349403 11.921 0.534388 12 0.727273 12C0.920157 12 1.10514 11.921 1.24153 11.7803C1.37792 11.6397 1.45455 11.4489 1.45455 11.25V9.75C1.45455 9.55109 1.37792 9.36032 1.24153 9.21967C1.10514 9.07902 0.920157 9 0.727273 9ZM15.2727 9C15.0798 9 14.8949 9.07902 14.7585 9.21967C14.6221 9.36032 14.5455 9.55109 14.5455 9.75V11.25C14.5455 11.4489 14.6221 11.6397 14.7585 11.7803C14.8949 11.921 15.0798 12 15.2727 12C15.4656 12 15.6506 11.921 15.787 11.7803C15.9234 11.6397 16 11.4489 16 11.25V9.75C16 9.55109 15.9234 9.36032 15.787 9.21967C15.6506 9.07902 15.4656 9 15.2727 9ZM11.6364 3.75H8.72727V2.79C8.94711 2.65912 9.12991 2.47118 9.25749 2.24488C9.38508 2.01857 9.45301 1.76177 9.45455 1.5C9.45455 1.10218 9.3013 0.720644 9.02852 0.43934C8.75574 0.158035 8.38577 0 8 0C7.61423 0 7.24426 0.158035 6.97148 0.43934C6.6987 0.720644 6.54545 1.10218 6.54545 1.5C6.54699 1.76177 6.61492 2.01857 6.74251 2.24488C6.8701 2.47118 7.05289 2.65912 7.27273 2.79V3.75H4.36364C3.78498 3.75 3.23003 3.98705 2.82086 4.40901C2.41169 4.83097 2.18182 5.40326 2.18182 6V12.75C2.18182 13.3467 2.41169 13.919 2.82086 14.341C3.23003 14.7629 3.78498 15 4.36364 15H11.6364C12.215 15 12.77 14.7629 13.1791 14.341C13.5883 13.919 13.8182 13.3467 13.8182 12.75V6C13.8182 5.40326 13.5883 4.83097 13.1791 4.40901C12.77 3.98705 12.215 3.75 11.6364 3.75ZM9.25091 5.25L8.88727 6.75H7.11273L6.74909 5.25H9.25091ZM12.3636 12.75C12.3636 12.9489 12.287 13.1397 12.1506 13.2803C12.0142 13.421 11.8292 13.5 11.6364 13.5H4.36364C4.17075 13.5 3.98577 13.421 3.84938 13.2803C3.71299 13.1397 3.63636 12.9489 3.63636 12.75V6C3.63636 5.80109 3.71299 5.61032 3.84938 5.46967C3.98577 5.32902 4.17075 5.25 4.36364 5.25H5.25091L5.81818 7.68C5.858 7.84641 5.95189 7.99373 6.08421 8.09744C6.21654 8.20115 6.37932 8.25499 6.54545 8.25H9.45455C9.62068 8.25499 9.78346 8.20115 9.91579 8.09744C10.0481 7.99373 10.142 7.84641 10.1818 7.68L10.7491 5.25H11.6364C11.8292 5.25 12.0142 5.32902 12.1506 5.46967C12.287 5.61032 12.3636 5.80109 12.3636 6V12.75Z"
 fill="white"/>
<ellipse cx="5.64221" cy="10.4939" rx="0.589474" ry="0.595142" fill="white"/>
<ellipse cx="8.16809" cy="10.4939" rx="0.589474" ry="0.595142" fill="white"/>
<ellipse cx="10.6945" cy="10.4939" rx="0.589474" ry="0.595142" fill="white"/>
</svg>;

const MessageAvatar = ({message, directionMine, userTeam}) => {
    const avatarUserMessage = (profileId) => {
        const user =  userTeam?.filter(({profile}) => profileId === profile.id)[0];
        if (user) {
             if ('avatar_url' in user.profile) {
                 return user.profile.avatar_url ? <IonImg alt="avatar" src={user.profile.avatar_url} /> : user.profile.user.username[0].toUpperCase();
             }
             return user.profile.user.username[0].toUpperCase();
        }
     }

     return <span>
        <span className="i-chats-dialogue-content-message-ponytail">
            {message.content_type === MESSAGE_CONTENT_TYPE_NOTE ? iconYellowPonytail : (directionMine ? (message.profile_id ? iconGreenPonytail : iconLightBluePonytail) : iconWhitePonytail)}
        </span>
        {directionMine && <span className={cx('i-chats-dialogue-content-message-avatar', {'i-chats-dialogue-content-message-avatar--blue': !message.profile_id})}>
            {message.profile_id ? avatarUserMessage(message.profile_id) : iconBotAvatar}
        </span>}
    </span>
}

const mapStateToProps = state => ({
    userTeam: state.Shops.activeShopAdministrators,
});


export default connect(mapStateToProps)(MessageAvatar);